import React from 'react';
import ReactDOM from 'react-dom/client';
import { msalReady } from './services/msalConfig';
import App from './App';

// Wait for MSAL to process any pending redirects before rendering React.
// This prevents BrowserRouter from clearing the hash that MSAL needs.
msalReady.then(() => {
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
});

